export const PASSPORT_BASE_URL = 'https://cf.passport.hpe.com/hppcf';
export const INFOSIGHT_APP_ID = '201443_OCULUS_PRO_HPE';
export const PASSPORT_REDIRECT_URL = window.location.href;
